<div class="body" [ngClass]="getBodyClass()">
  <app-breadcrumb></app-breadcrumb>
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
